import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Section,
  Button,
  RangePicker,
  FilterWraper,
} from "../../core";
import ReactToPrint from "react-to-print";
import InvoiceList from "../../components/InvoiceList";
import { getInvoiceWithCompanyId } from "../../helper/utils/api/invoice";
import { mapInvoicesForList } from "../../helper/utils/invoiceMap";
import { getCompanyId } from "../../helper/utils/companyId";
import { PrinterFilled } from "@ant-design/icons";
import { sale_report, initialState } from "../../hooks/saleReport";

import styled from "styled-components";
import { updateCurrentPath } from "../../redux/Action/pageRoot";
import Container from "../GenerateInvoice/PreviewReport";

const StyledButton = styled(Button)`
  display: inline-block;
`;

const SaleRegister = () => {
  const printComponent = React.useRef();
  const dispatchToAction = useDispatch();
  const [state, dispatch] = React.useReducer(sale_report, initialState);
  const [allInvoices, setAllInvoices] = React.useState([]);
  const companies = useSelector((state) => state.comapny?.companies || []);
  const [report, setReport] = React.useState(false);
  const [saleRecord, setSaleRecord] = React.useState(null);
  const [filter, setfilter] = React.useState(null);

  const companyId = getCompanyId();
  const companyDetail =
    companies.find(
      (item) => item._id === companyId || item.id === companyId
    ) || {};

  React.useEffect(() => {
    dispatchToAction(updateCurrentPath("Sale Register"));
  }, [dispatchToAction]);

  React.useEffect(() => {
    const loadInvoices = async () => {
      if (!companyId) return;
      try {
        const { data } = await getInvoiceWithCompanyId({
          companyId,
          limit: 500,
        });
        setAllInvoices(mapInvoicesForList(data?.result || data || []));
      } catch (error) {
        console.log("sale register load error", error);
      }
    };
    loadInvoices();
  }, [companyId]);

  const dateRange = (date, dateString) => {
    const min = dateString[0];
    const max = dateString[1];
    setfilter({
      from: min,
      to: max,
    });
    const filteredArray = allInvoices.filter((record) => {
      return record.invoice_date >= min && record.invoice_date <= max;
    });
    setSaleRecord(filteredArray);
    setReport(true);
  };

  const saleHandler = () => {
    dispatch({
      type: "SALE_REPORT",
      payload: {
        ...state,
        salereport: saleRecord,
        filter: filter,
      },
    });
  };

  return (
    <React.Fragment>
      <Grid fluid>
        <div className="">
          <Section padding="0px 20px 20px 20px" className="mt-20">
            <FilterWraper
              tittle="Generate Sale Register"
              search={false}
              dropDown={false}
              range={false}
              padding="20px"
            >
              <RangePicker format="YYYY-MM-DD" onChange={dateRange} />
              {report ? (
                <StyledButton
                  width="150px"
                  height="100%"
                  margin="0px 10px"
                  onClick={saleHandler}
                >
                  Genrate Sale Report
                </StyledButton>
              ) : null}
            </FilterWraper>
          </Section>

          {state.salereport ? (
            <>
              <ReactToPrint
                trigger={() => (
                  <Button
                    width="150px"
                    height="100%"
                    margin="10px 0px 10px auto"
                    className="btn"
                  >
                    <PrinterFilled /> Print this out!
                  </Button>
                )}
                content={() => printComponent.current}
              />
              <Container
                filter={filter}
                state={state.salereport}
                companyDetail={companyDetail}
                ref={printComponent}
              />
            </>
          ) : (
            <Section padding="20px" className="mt-20">
              <InvoiceList />
            </Section>
          )}
        </div>
      </Grid>
    </React.Fragment>
  );
};

export default SaleRegister;
